import { axiosClient } from "./axiosClient";
import { FIP_ENDPOINTS } from "./endpoints";

import {
    SearchFipRequest,
    RecentlySearchFipRequest,
    FiCategoryRequest,
} from "./api.types";

export const getFiCategories = async (payload: FiCategoryRequest) => {
    const res = await axiosClient.post(
        FIP_ENDPOINTS.CATEGORIES,
        payload
    );
    return res.data;
};

export const searchFip = async (payload: SearchFipRequest) => {
    const res = await axiosClient.post(
        FIP_ENDPOINTS.SEARCH,
        payload
    );
    return res.data;
};

export const getRecentlySearchFip = async (payload: RecentlySearchFipRequest) => {
    const res = await axiosClient.post(
        FIP_ENDPOINTS.RECENTLY_SEARCH_FIP,
        payload
    );
    return res.data;
};
